<template>
    <div class="container">
        <div class="QRcode">
            <div id="qrcode"></div>
            <p>路考/签约时请出示二维码</p>
        </div>
    </div>
</template>

<script>
import QRCode from 'qrcodejs2'
export default {
  mounted () {
    this.setQRCode()
  },
  methods: {
    setQRCode () {
      let _this = this
      new QRCode('qrcode', {//eslint-disable-line
        width: 110,
        height: 110,
        text: '{idCard: ' + _this.$store.state.idCar + '}',
        colorDark: '#000',
        colorLight: '#fff'
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.container{
    text-align: center
}
#qrcode {
    text-align: center;
    display: inline-block;
     margin: .52rem 0 .18rem 0;
    background: #fff;
    padding: .1rem;
    img {
      width: 132px;
      height: 132px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/pass-status/components/QRcode.vue